export default "/images/vendor/flag-icon-css/flags/4x3/bn.svg?513d1e4632edd7b884c6bf46bdd7cffd";